"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = show;
exports.PaymentMethodsModal = exports.PaymentMethodsBody = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _base = babelHelpers.interopRequireDefault(require("modals/base"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _AnimatedComponent = babelHelpers.interopRequireDefault(require("components/AnimatedComponent"));

var _LoginForm = require("components/LoginForm");

var _noty = require("noty");

var _class, _descriptor, _descriptor2, _descriptor3, _temp, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _temp2, _class5, _descriptor12, _descriptor13, _temp3, _class7, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _temp4, _class9, _descriptor20, _temp5;

var NoOp = function NoOp() {};

var OwnerUpdateForm = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(OwnerUpdateForm, _Component);

  function OwnerUpdateForm() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, OwnerUpdateForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(OwnerUpdateForm)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "refresh", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = Object.assign({
      global_error: null,
      loading: false
    }, _this.getInitialOwner());
    babelHelpers.initializerDefineProperty(_this, "modal", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(OwnerUpdateForm, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("form", {
        onSubmit: this.doUpdateForm
      }, _react.default.createElement("div", {
        className: "form-header"
      }, _react.default.createElement("h2", null, "Billing Information")), this.state.global_error ? _react.default.createElement(_LoginForm.ErrorLabel, {
        value: this.state.global_error
      }) : null, _react.default.createElement(_LoginForm.Owner, {
        id: "stripeOwner",
        disabled: this.state.loading,
        onChange: this.setOwner,
        value: this.state.owner
      }), _react.default.createElement("button", {
        className: _classList.default.join("btn", "btn-primary", this.state.loading ? "spinning" : ""),
        type: "submit",
        "data-spin": this.state.loading ? "true" : null,
        disabled: !this.canSubmitBilling()
      }, "Update"), _react.default.createElement("a", {
        onClick: this.cancel,
        href: "javascript:void(0)",
        className: "btn btn-link"
      }, "Cancel"));
    }
  }, {
    key: "setOwner",
    value: function setOwner(owner, owner_valid) {
      this.setState({
        owner: owner,
        owner_valid: owner_valid
      });
    }
  }, {
    key: "getInitialOwner",
    value: function getInitialOwner() {
      var r = {
        owner: {
          name: this.item.owner.name,
          line1: this.item.owner.address.line1,
          city: this.item.owner.address.city,
          state: this.item.owner.address.state,
          postal_code: this.item.owner.address.postal_code,
          country: this.item.owner.address.country
        },
        owner_valid: false
      };
      r.owner_valid = !Object.keys(r.owner).map(function (key) {
        return key == 'state' ? true : !!r.owner[key];
      }).some(function (value) {
        return !value;
      });
      return r;
    }
  }, {
    key: "canSubmitBilling",
    value: function canSubmitBilling() {
      return this.state.owner_valid;
    }
  }, {
    key: "doUpdateForm",
    value: function doUpdateForm(event) {
      var _this2 = this;

      event.preventDefault();

      if (this.canSubmitBilling()) {
        this.setState({
          loading: true
        }, function () {
          var x = Object.assign({}, _this2.state.owner);
          delete x.name;
          (0, _fetch.default)('purchase/stripe/update/owner', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: _this2.item.id,
              owner: {
                name: _this2.state.owner.name,
                address: x
              }
            })
          }).then(function (data) {
            if (data.ok) {
              if (data.status == 204) return {};
              return data.json();
            } else {
              throw data.json();
            }
          }).then(function (success) {
            (0, _noty.showNotificationText)('Your billing address has been updated.');

            _this2.modal.hide();

            _this2.refresh();
          }).catch(function (result) {
            _this2.setState({
              loading: false,
              global_error: result.error
            });
          });
        });
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.modal.hide();
    }
  }]);
  return OwnerUpdateForm;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "refresh", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setOwner", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setOwner"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doUpdateForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doUpdateForm"), _class.prototype), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "cancel", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "cancel"), _class.prototype)), _class);

var OwnerUpdateModal =
/*#__PURE__*/
function (_Modal) {
  babelHelpers.inherits(OwnerUpdateModal, _Modal);

  function OwnerUpdateModal(card) {
    var _this3;

    var resolve = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var reject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    babelHelpers.classCallCheck(this, OwnerUpdateModal);
    _this3 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(OwnerUpdateModal).call(this, 'login-form'));
    _this3.innerWrapper = false;
    _this3.hasModalTitleElement = false;
    Object.assign(babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)), {
      card: card,
      resolve: resolve,
      reject: reject
    });
    return _this3;
  }

  babelHelpers.createClass(OwnerUpdateModal, [{
    key: "showForm",
    value: function showForm() {
      var element = this.element;
      var E = element.querySelector('.form-body');

      _reactDom.default.render(_react.default.createElement(OwnerUpdateForm, {
        modal: this,
        refresh: this.resolve,
        item: this.card
      }), E);
    }
  }, {
    key: "show",
    value: function show() {
      var _babelHelpers$get,
          _this4 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(OwnerUpdateModal.prototype), "show", this)).call.apply(_babelHelpers$get, [this].concat(args)).then(function (element) {
        _this4.showForm();

        $(element).find('.modal').on('hidden.bs.modal', function (event) {
          _reactDom.default.unmountComponentAtNode(element.querySelector('.form-body'));

          $(element).remove();
        });
        return element;
      });
    }
  }, {
    key: "modalContent",
    get: function get() {
      return "<div class='form-body unscaled'></div>";
    }
  }]);
  return OwnerUpdateModal;
}(_base.default);

var ExpirationDateEntry = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ExpirationDateEntry, _Component2);

  function ExpirationDateEntry() {
    var _babelHelpers$getProt2;

    var _this5;

    babelHelpers.classCallCheck(this, ExpirationDateEntry);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this5 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(ExpirationDateEntry)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this5, "month", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "year", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "onChange", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "isValid", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "errorMessage", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "id", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "label", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    babelHelpers.initializerDefineProperty(_this5, "initIndex", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    _this5.state = {
      month: "00".concat(String(_this5.month)).substr(-2),
      year: String(_this5.year).substr(-2),
      divider: ' / '
    };
    return _this5;
  }

  babelHelpers.createClass(ExpirationDateEntry, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "form-group form-group-grid"
      }, _react.default.createElement("div", {
        className: "grid-row"
      }, _react.default.createElement("label", {
        for: this.id
      }, this.label)), _react.default.createElement("div", {
        className: "grid-row"
      }, _react.default.createElement("div", {
        className: "input-group"
      }, _react.default.createElement("input", {
        type: "text",
        className: _classList.default.join('form-control date-field', this.isValid === false ? 'invalid' : '', this.isValid === true ? 'valid' : ''),
        value: this.formattedValue(),
        onChange: this.handleChange,
        ref: this.inputRef
      }), this.isValid === true && _react.default.createElement("div", {
        className: "input-group-addon valid"
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "check"
      })), this.isValid === false && _react.default.createElement("div", {
        className: "input-group-addon invalid"
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "error"
      }))), this.errorMessage && _react.default.createElement("div", {
        className: "alert alert-danger"
      }, this.errorMessage)));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.initIndex != this.props.initIndex) {
        this.setState({
          month: String(this.month),
          year: String(this.year).substr(-2),
          divider: ' / '
        });
        return;
      }

      if (prevState.month != this.state.month || prevState.year != this.state.year) {
        if (this.state.month.length == 2 && this.state.year.length == 2) {
          var x = new Date();
          var my = 50 + x.getFullYear() % 100;
          var yr;
          yr = x.getFullYear() - x.getFullYear() % 100;
          if (Number(this.state.year) > my) yr -= 100;
          yr += Number(this.state.year);
          this.onChange(Number(this.state.month), yr);
        } else {
          this.onChange(NaN, NaN);
        }
      }
    }
  }, {
    key: "inputRef",
    value: function inputRef(node) {
      this.field = node;
    }
  }, {
    key: "formattedValue",
    value: function formattedValue() {
      var r = this.state.month;
      if (r.length == 2) r += this.state.divider;
      r += this.state.year;
      return r;
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var theValue = event.target.value;

      if (theValue == this.state.month + this.state.divider.substring(0, this.state.divider.length - 1)) {
        this.setState({
          divider: ''
        });
        return;
      }

      theValue = theValue.replace(/[^0-9\/]/g, '');
      var mm, yy;

      if (theValue.length == 0) {
        mm = yy = "";
      } else if (theValue.indexOf('/') == -1) {
        // No slash was entered.
        if (theValue.length == 1) {
          var showZero = true;

          if (theValue == '0' || theValue == '1') {
            mm = theValue;
            yy = "";
          } else {
            mm = "0" + theValue;
            showZero = false;
            yy = "";
          }

          if (!showZero && mm == '0') mm = '';
        } else {
          if (!(/^0[0-9]/.test(theValue) || /^1[12]/.test(theValue))) {
            theValue = '0' + theValue;
          }

          mm = theValue.substring(0, 2);
          yy = theValue.substring(2, 4);
        }
      } else {
        // There's a slash here.
        var _theValue$split = theValue.split('/');

        var _theValue$split2 = babelHelpers.slicedToArray(_theValue$split, 2);

        mm = _theValue$split2[0];
        yy = _theValue$split2[1];

        if (Number(mm) > 13) {
          yy = mm.substring(1) + yy;
          mm = '0' + mm.charAt(0);
        }

        mm = mm.substring(0, 2);
        yy = yy.substring(0, 2);
      }

      this.setState({
        month: mm,
        year: yy,
        divider: ' / '
      });
    }
  }]);
  return ExpirationDateEntry;
}(_react.Component), _temp2), (_descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "month", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "year", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "onChange", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (month, year) {};
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "isValid", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "errorMessage", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "label", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "initIndex", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "inputRef", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "inputRef"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "handleChange", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "handleChange"), _class3.prototype)), _class3);
var AddressInfo = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(AddressInfo, _Component3);

  function AddressInfo() {
    var _babelHelpers$getProt3;

    var _this6;

    babelHelpers.classCallCheck(this, AddressInfo);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this6 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(AddressInfo)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this6, "item", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "refresh", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    return _this6;
  }

  babelHelpers.createClass(AddressInfo, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "form-group billing-address"
      }, _react.default.createElement("div", {
        className: "address"
      }, _react.default.createElement("div", {
        className: "name"
      }, this.item.owner.name), _react.default.createElement("div", {
        className: "address1"
      }, this.item.owner.address.line1), this.item.owner.address.line2 && _react.default.createElement("div", {
        className: "address2"
      }, this.item.owner.address.line2), _react.default.createElement("div", {
        className: "locale"
      }, this.item.owner.address.city, ", ", this.item.owner.address.state, " ", this.item.owner.address.postal_code), _react.default.createElement("div", {
        className: "country"
      }, this.item.owner.address.country), _react.default.createElement("div", null, _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.updateAddress
      }, "Update billing address"))));
    }
  }, {
    key: "updateAddress",
    value: function updateAddress() {
      new OwnerUpdateModal(this.item, this.refresh).show();
    }
  }]);
  return AddressInfo;
}(_react.Component), _temp3), (_descriptor12 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "refresh", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "updateAddress", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "updateAddress"), _class5.prototype)), _class5);
var SourceEntry = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(SourceEntry, _Component4);

  function SourceEntry() {
    var _babelHelpers$getProt4;

    var _this7;

    babelHelpers.classCallCheck(this, SourceEntry);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this7 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(SourceEntry)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this7, "item", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "refresh", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "isDefault", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "requireAddress", _descriptor17, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "index", _descriptor18, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    babelHelpers.initializerDefineProperty(_this7, "isFailedCard", _descriptor19, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this7)));
    _this7.state = Object.assign({
      expanded: false,
      isDefault: _this7.isDefault,
      month: _this7.item.exp_month,
      year: _this7.item.exp_year,
      index: 0,
      loading: false
    }, _this7.isValid(_this7.item.exp_month, _this7.item.exp_year));
    _this7.styleName = ['height', 'opacity'];
    _this7.baseStyle = {
      height: '0px',
      opacity: 0,
      overflow: 'hidden'
    };
    _this7.outerStyleName = ['opacity'];
    _this7.outerBaseStyle = {
      opacity: .6
    };
    return _this7;
  }

  babelHelpers.createClass(SourceEntry, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this8 = this;

      if (this.isFailedCard) {
        setTimeout(function () {
          return _this8.setState({
            expanded: true
          });
        }, 0);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.index != this.props.index) {
        this.setState({
          expanded: this.isFailedCard
        });
      }
    }
  }, {
    key: "isValid",
    value: function isValid(month, year) {
      var isValid = false;
      var reason = "";

      if (isNaN(month) || isNaN(year)) {
        reason = "Please specify a valid expiration date.";
      } else if (month >= 1 && month <= 12 && year >= new Date().getFullYear()) {
        if (year == new Date().getFullYear()) {
          if (month - 1 >= new Date().getMonth()) {
            isValid = true;
          } else {
            reason = "Please specify an expiration date in the future.";
          }
        } else {
          isValid = true;
        }
      } else {
        reason = "Please specify an expiration date in the future.";
      }

      return {
        isValid: isValid,
        reason: reason
      };
    }
  }, {
    key: "start",
    value: function start() {
      return {
        height: 0,
        opacity: 0
      };
    }
  }, {
    key: "end",
    value: function end(el) {
      return {
        height: el.scrollHeight,
        opacity: 1
      };
    }
  }, {
    key: "format",
    value: function format(value, name) {
      return name == 'opacity' ? value : "".concat(value, "px");
    }
  }, {
    key: "finishElementStyle",
    value: function finishElementStyle(element, enter) {
      if (enter) {
        Object.assign(element.style, {
          opacity: 1,
          height: ''
        });
      } else {
        Object.assign(element.style, {
          opacity: 0,
          height: '0px'
        });
      }
    }
  }, {
    key: "updateCard",
    value: function updateCard(event) {
      var _this9 = this;

      event.preventDefault();

      if (this.isValid) {
        this.setState({
          loading: true
        }, function () {
          (0, _fetch.default)('purchase/stripe/update/card', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: _this9.item.id,
              exp_month: Number(_this9.state.month),
              exp_year: Number(_this9.state.year),
              isDefault: _this9.state.isDefault
            })
          }).then(function (body) {
            if (body.ok) {
              if (body.status == 204) return {};
              return body.json();
            }

            throw body.json();
          }).then(function (result) {
            (0, _noty.showNotificationText)('The card details have been updated.');

            _this9.setState({
              global_error: ""
            }, function () {
              _this9.refresh();
            });
          }).catch(function (err) {
            _this9.setState(function (st) {
              return {
                global_error: err.error,
                index: st.index++
              };
            });
          });
        });
      }
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.setState(function (_ref) {
        var expanded = _ref.expanded;
        return {
          expanded: !expanded
        };
      });
    }
  }, {
    key: "setCardDate",
    value: function setCardDate(month, year) {
      var _this$isValid = this.isValid(month, year),
          isValid = _this$isValid.isValid,
          reason = _this$isValid.reason;

      this.setState({
        month: month,
        year: year,
        isValid: isValid,
        reason: reason
      });
    }
  }, {
    key: "setDefault",
    value: function setDefault(event) {
      this.setState({
        isDefault: event.target.checked
      });
    }
  }, {
    key: "canDelete",
    value: function canDelete() {
      return !this.isDefault;
    }
  }, {
    key: "deleteCard",
    value: function deleteCard(event) {
      var _this10 = this;

      event.preventDefault();

      if (this.canDelete()) {
        this.setState({
          loading: true
        }, function () {
          (0, _fetch.default)('purchase/stripe/delete/card', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: _this10.item.id
            })
          }).then(function (body) {
            if (body.ok) {
              if (body.status == 204) return {};
              return body.json();
            }

            throw body.json();
          }).then(function (result) {
            (0, _noty.showNotificationText)('The card has been deleted.');

            _this10.setState({
              global_error: ""
            }, function () {
              _this10.refresh();
            });
          }).catch(function (err) {
            _this10.setState(function (st) {
              return {
                global_error: err.error,
                index: st.index++
              };
            });
          });
        });
      }
    }
  }, {
    key: "outerStart",
    value: function outerStart() {
      return {
        opacity: 0.6
      };
    }
  }, {
    key: "outerEnd",
    value: function outerEnd() {
      return {
        opacity: 1
      };
    }
  }, {
    key: "outerFinishElementStyle",
    value: function outerFinishElementStyle() {}
  }, {
    key: "render",
    value: function render() {
      var _React$createElement;

      return _react.default.createElement("section", {
        className: _classList.default.join("payment-method", this.state.expanded && "open")
      }, _react.default.createElement("div", {
        className: _classList.default.join('main', this.state.expanded && 'expanded'),
        onClick: this.toggle
      }, _react.default.createElement("div", {
        className: "payment-type-icon",
        "data-type": this.item.brand
      }), _react.default.createElement("div", {
        className: "payment-info"
      }, _react.default.createElement("div", {
        className: "title"
      }, _react.default.createElement("span", null, this.item.brand, " ending in ", this.item.last4), this.isDefault && _react.default.createElement("span", {
        className: "default-marker"
      }, "(default)")), _react.default.createElement("div", {
        className: "expires"
      }, "Expires ", ('00' + this.item.exp_month).substr(-2) + ' ', "/", ' ' + String(this.item.exp_year).substr(-2))), _react.default.createElement("div", {
        className: "expando"
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "keyboard_arrow_down"
      }))), _react.default.createElement(_AnimatedComponent.default, (_React$createElement = {
        styleName: this.styleName,
        start: this.start,
        end: this.end,
        boxStyle: this.outerBaseStyle,
        enter: this.state.expanded,
        format: this.format
      }, babelHelpers.defineProperty(_React$createElement, "boxStyle", this.baseStyle), babelHelpers.defineProperty(_React$createElement, "finishElementStyle", this.finishElementStyle), babelHelpers.defineProperty(_React$createElement, "wrapperType", "footer"), _React$createElement), _react.default.createElement("form", {
        class: "update-form",
        onSubmit: this.updateCard
      }, this.state.global_error && _react.default.createElement(_LoginForm.ErrorLabel, {
        value: this.state.global_error
      }), !this.state.global_error && this.isFailedCard && _react.default.createElement(_LoginForm.ErrorLabel, {
        value: "This card cannot be used for transactions. Please update it or add a new card."
      }), _react.default.createElement(ExpirationDateEntry, {
        initIndex: this.state.index,
        label: "Update expiration date (MM/YY)",
        id: "expirationDate",
        errorMessage: this.state.isValid === false ? this.state.reason : null,
        isValid: this.state.isValid,
        month: this.state.month,
        year: this.state.year,
        onChange: this.setCardDate
      }), !this.isDefault && _react.default.createElement("div", {
        className: "checkbox"
      }, _react.default.createElement("label", null, _react.default.createElement("input", {
        type: "checkbox",
        onClick: this.setDefault,
        checked: this.state.isDefault,
        value: this.state.isDefault
      }), "Make this my default payment method.")), this.requireAddress && _react.default.createElement(AddressInfo, {
        refresh: this.refresh,
        item: this.item
      }), _react.default.createElement("footer", null, this.canDelete() ? _react.default.createElement("button", {
        onClick: this.deleteCard,
        type: "button",
        className: "btn btn-danger"
      }, "Delete") : _react.default.createElement("p", {
        className: "footer-alert"
      }, "To delete this payment method, you must first add a new payment method and make it your default."), _react.default.createElement("button", {
        type: "submit",
        className: "btn btn-primary"
      }, "Save")))));
    }
  }]);
  return SourceEntry;
}(_react.Component), _temp4), (_descriptor14 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "refresh", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "isDefault", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "requireAddress", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "index", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "isFailedCard", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "start", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "start"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "end", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "end"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "format", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "format"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "finishElementStyle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "finishElementStyle"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "updateCard", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "updateCard"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "toggle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "toggle"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "setCardDate", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "setCardDate"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "setDefault", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "setDefault"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "deleteCard", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "deleteCard"), _class7.prototype)), _class7);
var PaymentMethodsBody = (_class9 = (_temp5 =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(PaymentMethodsBody, _Component5);

  function PaymentMethodsBody() {
    var _babelHelpers$getProt5;

    var _this11;

    babelHelpers.classCallCheck(this, PaymentMethodsBody);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this11 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt5 = babelHelpers.getPrototypeOf(PaymentMethodsBody)).call.apply(_babelHelpers$getProt5, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this11, "input", _descriptor20, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    _this11.state = {
      methods: null,
      requireAddress: null,
      index: 0,
      failedCard: _this11.input ? _this11.input.failed : null
    };
    return _this11;
  }

  babelHelpers.createClass(PaymentMethodsBody, [{
    key: "refresh",
    value: function refresh() {
      var _this12 = this;

      _promisePolyfill.default.all([(0, _fetch.default)('purchase/stripe/account').then(function (data) {
        return data.json();
      }), (0, _fetch.default)('purchase/stripe/key').then(function (data) {
        return data.json();
      })]).then(function (_ref2) {
        var _ref3 = babelHelpers.slicedToArray(_ref2, 2),
            methods = _ref3[0],
            requireAddress = _ref3[1].requireAddress;

        var x = {
          methods: methods,
          requireAddress: requireAddress,
          index: _this12.state.index + 1
        };
        if (x.index > 1) x.failedCard = null;

        _this12.setState(x);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.refresh();
    }
  }, {
    key: "addPaymentMethod",
    value: function addPaymentMethod() {
      (0, _LoginForm.showNewCard)().then(this.refresh);
    }
  }, {
    key: "render",
    value: function render() {
      var _this13 = this;

      var items = [];

      if (this.state.methods && this.state.methods.sources) {
        items = this.state.methods.sources.filter(function (source) {
          return _this13.state.methods.defaultSource == source.id;
        });
        items = items.concat(this.state.methods.sources.filter(function (source) {
          return _this13.state.methods.defaultSource != source.id;
        }));
      }

      return _react.default.createElement("div", {
        className: "payment-methods"
      }, items.map(function (source) {
        return _react.default.createElement(SourceEntry, {
          index: _this13.state.index,
          isFailedCard: _this13.state.failedCard == source.id,
          isDefault: _this13.state.methods.defaultSource == source.id,
          requireAddress: _this13.state.requireAddress,
          item: source,
          key: source.id,
          refresh: _this13.refresh
        });
      }), _react.default.createElement("a", {
        className: "btn btn-primary",
        href: "javascript:void(0)",
        onClick: this.addPaymentMethod
      }, "Add payment method"));
    }
  }]);
  return PaymentMethodsBody;
}(_react.Component), _temp5), (_descriptor20 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "input", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "refresh", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "refresh"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "addPaymentMethod", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "addPaymentMethod"), _class9.prototype)), _class9);
exports.PaymentMethodsBody = PaymentMethodsBody;

var PaymentMethodsModal =
/*#__PURE__*/
function (_Modal2) {
  babelHelpers.inherits(PaymentMethodsModal, _Modal2);

  function PaymentMethodsModal(data) {
    var _this14;

    babelHelpers.classCallCheck(this, PaymentMethodsModal);
    _this14 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PaymentMethodsModal).call(this, 'payment-methods-modal'));
    _this14.innerWrapper = false;
    _this14.data = data;
    return _this14;
  }

  babelHelpers.createClass(PaymentMethodsModal, [{
    key: "show",
    value: function show() {
      var _babelHelpers$get2,
          _this15 = this;

      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return (_babelHelpers$get2 = babelHelpers.get(babelHelpers.getPrototypeOf(PaymentMethodsModal.prototype), "show", this)).call.apply(_babelHelpers$get2, [this].concat(args)).then(function (element) {
        _reactDom.default.render(_react.default.createElement(PaymentMethodsBody, {
          input: _this15.data
        }), element.querySelector('.form-body'));

        $(element).find('.modal').on('hidden.bs.modal', function (event) {
          _reactDom.default.unmountComponentAtNode(element.querySelector('.form-body'));

          $(element).remove();
        });
        return element;
      });
    }
  }, {
    key: "title",
    get: function get() {
      return 'My Payment Methods';
    }
  }, {
    key: "modalContent",
    get: function get() {
      return "\n\t\t\t<div class='form-body'></div>\n\t\t";
    }
  }]);
  return PaymentMethodsModal;
}(_base.default);

exports.PaymentMethodsModal = PaymentMethodsModal;

function show() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  new PaymentMethodsModal(data).show();
}